var EqQueryFileLoader = /** @class */ (function () {
    function EqQueryFileLoader(context) {
        this.context = context;
    }
    EqQueryFileLoader.prototype.getQueryFile = function (options) {
        var query = options.query || this.context.getQuery();
        var url = this.context.resolveEndpoint('GetQueryFile', { modelId: query.getModel().getId(),
            format: options.format || 'xml' });
        var http = this.context.getServices().getHttpClient();
        var actionResult = http.post(url, {
            query: query.toJSONData()
        });
        var request = actionResult.getRequest();
        return actionResult.then(function (responseData) {
            var blob = new Blob([responseData]);
            var dispositionHeader = request.getXMLHttpRequest().getResponseHeader("Content-Disposition");
            var fileName = dispositionHeader
                ? dispositionHeader.match(/filename="(.*)"/)[1]
                : 'query.json';
            if (options.fileName) {
                fileName = options.fileName
                    + fileName.substring(fileName.lastIndexOf('.'));
            }
            if (window.navigator['msSaveOrOpenBlob']) {
                // Internet Explorer
                window.navigator['msSaveOrOpenBlob'](blob, fileName);
            }
            else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style.display = "none";
                a.href = window.URL.createObjectURL(blob);
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            }
        });
    };
    EqQueryFileLoader.prototype.uploadQueryFile = function (options) {
        options = options || {};
        var query = options.query || this.context.getQuery();
        var url = this.context.resolveEndpoint('UploadQueryFile', { modelId: query.getModel().getId() });
        var http = this.context.getServices().getHttpClient();
        return http.post(url, options.data, {
            dataType: 'form-data'
        })
            .then(function (responseData) {
            return responseData.query;
        });
    };
    return EqQueryFileLoader;
}());
export { EqQueryFileLoader };
//# sourceMappingURL=eqs_query_file_loader.js.map